module.exports = __webpack_public_path__ + "static/media/mainbuilding_1.14548f56.png";